"use client";

import { Analytics } from "@vercel/analytics/next";

/** Vercel Analytics; GTM lives in `app/layout.tsx` via `@next/third-parties`. */
export default function Tracking() {
  return <Analytics />;
}
